module.exports = __webpack_public_path__ + "static/media/portfolioImage.c6dde47a.png";